import SaveGameModel from "../../model/SaveGameModel";

export default class SavegameStrategy {
    /**
     * @constructor
     * @param {SaveGameModel} saveGameModel 
     */
    constructor(saveGameModel) {
        this._saveGameModel = saveGameModel;
    }

    async peek() {
        throw new Error('Override peek() method in SavegameStrategy subclass');
    }

    async load() {
        throw new Error('Override load() method in SavegameStrategy subclass');
    }

    async save() {
        throw new Error('Override save() method in SavegameStrategy subclass');
    }

    async clear() {
        throw new Error('Override clear() method in SavegameStrategy subclass');
    }
}